const recordsCacheByKey = new Map()

const getRecordsCache = key => {
	let cache = recordsCacheByKey.get(key)
	if (!cache) {
		cache = new WeakMap()
		recordsCacheByKey.set(key, cache)
	}
	return cache
}

const joinRefsMatch = (cachedJoinRefs, joinRefs) => {
	if (!cachedJoinRefs) return false
	if (joinRefs.length !== cachedJoinRefs.length) return false
	return joinRefs.every((joinRef, index) => cachedJoinRefs[index] === joinRef)
}

const getCachedRecord = ({key, record, joinRefs = []}) => {
	const cachedRecord = getRecordsCache(key).get(record)
	if (!cachedRecord || !joinRefsMatch(cachedRecord.joinRefs, joinRefs)) return null
	return cachedRecord.modelInstance
}

const setCachedRecord = ({key, record, joinRefs = [], modelInstance}) => {
	getRecordsCache(key).set(record, {joinRefs, modelInstance})
}

export {getCachedRecord, setCachedRecord}
